import $ from "jquery";

const ares = {
	ico: '',

	init() {
		const $ico = $("#billingAddress_ico");
		this.ico = $ico.val();

		$ico.on('keyup', () => {
			if (this.verifyIco($ico.val())) {
				this.loadByIco($ico.val());
			} else {
				this.clearData();
			}
		});
	},

	loadByIco(ico) {
		this.ico = ico;
		if (ico === '') return;

		this.overlayShow();

		$.ajax(ROOT, {
			type: 'POST',
			data: {
				page: 'ares',
				ico: ico
			},
			success: (response) => {
				this.fillData(response);
			},
			error: (response) => {
				this.error();
			},
			async: false,
			dataType: 'json'
		});
	},

	fillData(data) {
		this.overlayHide();
		if (data) {
			if (data['response'] === 'OK') {
				this.ico = data['ico'];

				let address = data['street'] + ' ' + data['streetNumber1'];
				if (data['streetNumber2'] !== '') address = address + '/' + data['streetNumber2'];

				$("#billingAddress_dic").val(data['dic']);
				$("#billingAddress_company").val(data['company']);
				$("#billingAddress_street").val(address);
				$("#billingAddress_city").val(data['city']);
				$("#billingAddress_zip").val(data['zip']);
			} else {
				let message = '';
				if (data['error'] === 'invalid_ico') {
					message = 'Údaje o firmě se nepovedlo načíst. Zadali jste IČ správně?';
				}
				if (data['error'] === 'response_fail') {
					message = 'Nepodařilo se spojit s registrem IČ v databázi ARES, zkuste to případně později.';
				}
				iziToast.warning({
					title: 'Chyba',
					message: message,
					position: 'center'
				});
			}
		}
	},

	clearData() {
		$("#billingAddress_dic").val('');
		$("#billingAddress_company").val('');
		$("#billingAddress_street").val('');
		$("#billingAddress_city").val('');
		$("#billingAddress_zip").val('');
	},

	error() {
		this.overlayHide();
		iziToast.warning({
			title: 'Chyba',
			message: 'Nepodařilo se spojit s registrem IČ v databázi ARES, zkuste to případně později.',
			position: 'center'
		});
	},

	overlayShow() {
		$.LoadingOverlay("show", {
			background: "rgba(225, 225, 225, 0.5)",
			imageColor: "#808080",
			size: "70px"
		});
	},

	overlayHide() {
		$.LoadingOverlay("hide");
	},

	verifyIco(ico) {
		ico = "" + ico;

		if (this.numDigits(ico) === 8) {
			let a = 0;
			let c = 0;
			for (let i = 0; i < 7; i++) {
				a += parseInt(ico.charAt(i)) * (8 - i);
			}

			a %= 11;
			if (a === 0) {
				c = 1;
			} else if (a === 1) {
				c = 0;
			} else {
				c = 11 - a;
			}

			return parseInt(ico.charAt(7)) === c;
		}

		return false;
	},

	numDigits(x) {
		return (Math.log10((x ^ (x >> 31)) - (x >> 31)) | 0) + 1;
	}
};

$(function (){
	ares.init();
});